<template>
    <div>
        <a
            v-if="!isForm"
            class="btn"
            :class="cssClasses + ((disabled)? ' disabled' : '')"
            :aria-disabled="disabled"
            :aria-label="ariaLabel"
            :href="actionUrl"
            :data-oevent-category="tmsData.category"
            :data-oevent-action="tmsData.action"
            :data-oevent-label="tmsData.label"
            :role="((isRoleButton)? 'button' : null)"
            :data-bs-toggle="((isModalOpener)? 'modal' : null)"
        >
            <span :class="{ 'd-lg-none': withDesktopButton }">{{ buttonLabel }}</span>
            <span v-if="withDesktopButton" class="d-none d-lg-inline-block">{{ desktopButtonLabel }}</span>
        </a>
        <form
            v-else
            method="post"
            role="form"
            :aria-label="'Formulaire ' + buttonLabel"
            :action="actionUrl"
        >
            <input type="hidden" name="token" :value="token">
            <input
                v-for="(value, name) in actionFormParams"
                type="hidden"
                :name="name"
                :value="value"
            >
            <button
                type="submit"
                class="btn"
                :class="cssClasses + ((disabled)? ' disabled' : '')"
                :aria-disabled="disabled"
                :aria-label="ariaLabel"
                :data-oevent-category="tmsData.category"
                :data-oevent-action="tmsData.action"
                :data-oevent-label="tmsData.label"
            >
                <span :class="{ 'd-lg-none': withDesktopButton }">{{ buttonLabel }}</span>
                <span v-if="withDesktopButton" class="d-none d-lg-inline-block">{{ desktopButtonLabel }}</span>
            </button>
        </form>
    </div>
</template>

<script>
export default {
    name: "SimpleButtonCta",
    props: {
        buttonLabel: {
            type: String,
            required: true
        },
        desktopButtonLabel: {
            type: String,
            required: false,
            default: undefined
        },
        cssClasses: {
            type: String,
            required: false,
            default: "btn-primary"
        },
        ariaLabel: {
          type: String,
          required: false,
          default: null
        },
        actionUrl: {
            type: String,
            required: true
        },
        tmsData: {
            type: Object,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        isModalOpener: {
            type: Boolean,
            required: false,
            default: false
        },
        actionFormParams: {
            type: Object,
            required: false,
            default() {
                return {};
            }
        }
    },
    computed: {
        withDesktopButton() {
            return (this.desktopButtonLabel) && (this.desktopButtonLabel !== "")
        },
        isRoleButton() {
            return this.isModalOpener
        },
        isForm() {
            return this.actionFormParams && Object.keys(this.actionFormParams).length > 0
        },
        token() {
            return document.querySelector('[data-token]').getAttribute('data-token')
        }
    }
}
</script>
